import { render } from "./TextAreaUi.vue?vue&type=template&id=6c7c7b22&ts=true"
import script from "./TextAreaUi.vue?vue&type=script&lang=ts"
export * from "./TextAreaUi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__